import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=37069a5e&scoped=true&"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard.vue?vue&type=style&index=0&id=37069a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37069a5e",
  null
  
)

export default component.exports